<div class="sp-mt-8" [uiGutter]="[0, 24]" ui-row>
  <div class="sp-pt-0" [uiXs]="24" ui-col>
    <div class="sp-mb-12 mood-container" ui-row uiAlign="middle">
      <div [uiXs]="22" ui-col>
        <div class="fw-600 fs-16px">{{ "manage_reflections_mood_title" | localize }}</div>
        <div class="sp-pb-12">{{ "manage_reflections_mood_text" | localize }}</div>
      </div>
      <div class="mood-toggle" [uiXs]="2" ui-col>
        <ui-toggle [attr.aria-label]="'mood_section' | localize" [ngModel]="isMoodEnabled" (ngModelChange)="toggleMoodStatus($event)" uiType="toggle-text"></ui-toggle>
      </div>
    </div>

    <div class="sp-mb-12 notes-container" ui-row uiAlign="middle">
      <div [uiXs]="22" ui-col>
        <div class="fw-600 fs-16px">{{ "manage_reflections_notes_title" | localize }}</div>
        <div class="sp-pb-12">{{ "manage_reflections_notes_text" | localize }}</div>
      </div>
      <div class="notes-toggle" [uiXs]="2" ui-col>
        <ui-toggle [attr.aria-label]="'notes_section' | localize" [ngModel]="isNotesEnabled" (ngModelChange)="toggleNotesStatus($event)" uiType="toggle-text"></ui-toggle>
      </div>
    </div>

    <div class="fw-600 fs-16px" [attr.aria-label]="'questions_section' | localize" tabindex="0" ui-row>{{ "manage_reflections_questions" | localize }}</div>
    <div ui-row>{{ "manage_reflections_question_text" | localize }}</div>
  </div>
  <div class="sp-pb-0" [formGroup]="formGroup" [uiXs]="24" ui-col>
    <div formArrayName="questions" ui-row>
      <div class="sp-p-0 sp-mb-16" *ngFor="let question of getQuestions.controls; let key = index" [uiXs]="24" ui-col>
        <div [formGroupName]="key" ui-row uiAlign="middle">
          <div *ngIf="!question.value.isDefault && question.value.isEditModeEnabled" [uiXs]="24" ui-col>
            <label class="fs-12px fw-400" for="edit-question-input">{{ "manage_reflections_edit_question" | localize }}</label>
          </div>
          <div [uiXs]="22" ui-col>
            <ui-form-item class="sp-mb-0" ui-row>
              <ui-form-control class="question-box" ui-col>
                <ui-input-group class="question-input" [uiSuffix]="suffixTemplateInfo">
                  <div class="question-text" *ngIf="question.value.isDefault || !question.value.isEditModeEnabled">{{ question.value.text }}</div>
                  <input
                    id="edit-question-input"
                    *ngIf="!question.value.isDefault && question.value.isEditModeEnabled"
                    [attr.aria-label]="'editing_question_input_label' | localize : { questionLength, questionMaxLength }"
                    [maxlength]="questionMaxLength"
                    [placeholder]="'manage_check_ins_question_placeholder' | localize"
                    [autofocus]
                    (keydown)="updateCounter(question.value.text.length)"
                    (keydown.enter)="updateQuestion({ id: question.value.id, text: question.value.text }, key)"
                    ui-input
                    type="text"
                    formControlName="text" />
                  <ng-template #suffixTemplateInfo>
                    <button
                      class="edit-question-button"
                      *ngIf="!question.value.isDefault && !question.value.isEditModeEnabled"
                      [attr.aria-label]="question.value.text + ' ' + ('edit_custom_question' | localize)"
                      (click)="enableQuestionEditMode(question.value.id, question.value.text.length)"
                      (keydown.enter)="enableQuestionEditMode(question.value.id, question.value.text.length)"
                      ui-button
                      uiType="link">
                      <i class="fs-16px text-color-gray-9" ui-icon uiType="edit"></i>
                    </button>
                  </ng-template>
                </ui-input-group>
              </ui-form-control>
            </ui-form-item>
          </div>
          <div *ngIf="!question.value.isDefault && question.value.isEditModeEnabled" [uiXs]="2" ui-col>
            <ui-form-item ui-row uiJustify="center">
              <ui-form-control ui-col>
                <button
                  class="delete-question-button"
                  [attr.aria-label]="'delete_question' | localize"
                  (keydown.enter)="deleteQuestion({ questionId: question.value.id, index: key })"
                  (click)="deleteQuestion({ questionId: question.value.id, index: key })"
                  ui-button
                  uiType="link">
                  <i class="fs-16px text-color-gray-9" ui-icon uiType="trash-bin"></i>
                </button>
              </ui-form-control>
            </ui-form-item>
          </div>
          <div *ngIf="!question.value.isEditModeEnabled" [uiXs]="2" ui-col>
            <ui-form-item ui-row uiJustify="center">
              <ui-form-control ui-col>
                <div class="questions-toggle">
                  <ui-toggle
                    [attr.aria-label]="'Toggle, ' + (question.value.isDefault ? 'default' : 'custom') + ' question: ' + question.value.text"
                    (ngModelChange)="updateQuestion({ id: question.value.id, isEnabled: question.value.isEnabled }, key)"
                    uiType="toggle-text"
                    formControlName="isEnabled"></ui-toggle>
                </div>
              </ui-form-control>
            </ui-form-item>
          </div>
          <ng-container *ngIf="!question.value.isDefault && question.value.isEditModeEnabled">
            <div [uiXs]="12" ui-col>
              <div class="sp-mb-10 fs-10px text-color-gray-9">{{ "manage_reflections_press_enter_to_save" | localize }}</div>
            </div>
            <div class="fs-12px text-color-gray-9 character-counter" [uiXs]="10" ui-col>{{ questionLength }}/{{ questionMaxLength }}</div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
